import React from 'react';
import { Label } from '@cimpress/react-components';

const LabelDemo = () => (
  <div className="row">
    <div className="col-md-12">
      <Label text="Default" />
      <Label text="Primary" status="primary" />
      <Label text="Success" status="success" />
      <Label text="Warning" status="warning" />
      <Label text="Danger" status="danger" />
      <Label text="Info" status="info" />
      <Label text="Custom added class" className="specialized-added-class" style={{ color: 'green' }} />
      <Label text="Large" status="info" size="lg" />
      <Label text="Small" status="info" size="sm" />
    </div>
  </div>
);

export default LabelDemo;
